import 'ng-csv';
import 'angular-modal-service';
import ConfigsModule from '../../configs/configs';
import ServicesModule from '../../services/services';
import ResourcesModule from '../../resources/resources';
import StopReasonModal from './stopReasonModal';
import {normalizeTimeframe} from '../../common/datetime/date-ranges';
import template from './campaignsIndex.jade';
import stopReasonModalTemplate from './stopReasonModal.jade';

export class CampaignsIndexController {
  /* @ngInject */
  constructor($stateParams, currentGame, CampaignsResource, CampaignAnalyticsResource, GamesResource, SegmentsResource, CohortsResource, $filter, $q, ggTable, $localStorage, notify, currentUser, featureFlagsHelper, hideThatProduct, ModalService, stopReasonsOptions) {
    this.$stateParams = $stateParams;
    this.ModalService = ModalService;
    this.stopReasonsOptions = stopReasonsOptions;
    this.CampaignsResource = CampaignsResource;
    this.CampaignAnalyticsResource = CampaignAnalyticsResource;
    this.GamesResource = GamesResource;
    this.translate = $filter('translate');
    this.SegmentsResource = SegmentsResource;
    this.CohortsResource = CohortsResource;
    this.apiDate = $filter('apiDate');
    this.notify = notify;
    this.$q = $q;
    this.$localStorage = $localStorage;
    this.featureFlagsHelper = featureFlagsHelper;
    this.hideThatProduct = hideThatProduct;
    this.currentGame = currentGame;
    this.campaignStatusFilterValue = 'active';
    this.isResourceBeingLoaded = false;
    this.timeframe = normalizeTimeframe(this.$localStorage.timeframe);
    this.timeframeChange = new Rx.BehaviorSubject(this.timeframe);
    this.campaignsTable = new ggTable({
      count: 30,
      customFilters: {
        status(data, value) {
          return data.filter(item => {
                switch (value) {
                  case 'all':
                    return true;
                  case 'inactive':
                    return item.status === 'paused';
                  case 'active':
                    return item.status === 'active' || item.status === 'paused_due_to_budget' || item.status === 'paused_due_to_media_cost';
                  default:
                    return false;
                }
              }
          )},
        inIds(data, ids) {
          return data.filter(item => {
            return _.isEmpty(ids) || _.includes(ids, item.id);
          })
        }
      }
    });
    currentUser.subscribe((user) => {
      if(user) {
        this.showEngagementCampaignActions = !user.hasRole(['BUYER_ONLY']);
        this.showAcquisitionCPMActions = true;
        this.hideAcquisitionProduct = this.hideThatProduct.hideAcquisitionProduct(user);
      }
    });

    this.getCreatives(this.$stateParams.gameId);
    this.getCurrency();
    this.getCampaignsStatistics();
    this.getCampaignsRoi7();
    this.filterByStatus('active');

    this.creativeSearchText = '';
  }

  resetAllCreatives() {
    this.allCreatives.forEach(c => c.selected = false);
    this.filterByCreatives();
  }

  getCreatives(gameId) {
    return this.GamesResource.one(gameId).one('creatives').get()
        .then(creatives => {
          // Group creatives by id and name
          const groupedCreatives = _.groupBy(creatives, creative => `${creative.id}-${creative.external_name}`);
          // Map through grouped creatives and create a new structure
          const result = _.map(groupedCreatives, (group, key) => {
            const [id, external_name] = key.split('-');
            const campaignIds = _.uniq(_.map(group, 'campaign_id'));
            return {
              id: Number(id),
              name: external_name,
              label: external_name === 'undefined' ? `N/A (${Number(id)})` : `${external_name} (${Number(id)})`,
              campaign_ids: campaignIds
            };
          });
          this.allCreatives = result;
        })
  }

  onTimeframeChange() {
    this.$localStorage.timeframe = this.timeframe;
    this.timeframeChange.onNext(this.timeframe);
    this.getCampaignsStatistics();
    this.getCampaignsRoi7();
  }

  refreshData() {
    this.timeframeChange.onNext(this.$localStorage.timeframe);
    this.getCampaignsRoi7();
  }

  getCurrency() {
    this.currency = 'USD';
  }

  toggleSelection(creative) {
    creative.selected = !creative.selected;
    this.filterByCreatives();
  };

  isNumeric(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  getCampaignsRoi7() {
    this.d7_total = undefined;
    let query = {
      game_id: this.$stateParams.gameId,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate),
      breakdown_dimension: 'campaign_id',
      metric: 'roi',
      campaign_type: 'Engagement,EngagementCPC,EngagementCPA,EngagementCPI,Organic,Acquisition,AcquisitionCPM,BrandingCPM',
    };
    this.CohortsResource.one().get(query)
        .then(result => {
          this.d7_total = result.data.summary.d7_total;
        });
  }

  getCampaignsStatistics() {
    this.CampaignAnalyticsResource.one('overview-by-game').get({
      game_id: this.$stateParams.gameId,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate)
    }).then((res) => {
      const conversions = (res.acquisition_overview_analytics_data ? res.acquisition_overview_analytics_data.leads : 0) + (res.engagement_overview_analytics_data ? res.engagement_overview_analytics_data.engaged_players : 0);
      this.overviewData = {
        Acquisition: res.acquisition_overview_analytics_data,
        Engagement: res.engagement_overview_analytics_data,
        all: _.merge(
            {},
            res.total_overview_analytics_data,
            {
              conversions: conversions,
              ecpe: conversions ? res.total_overview_analytics_data.cost / conversions : 0
            }
        )
      };
    })
  }

  get selectedCampaigns() {
    return this.campaignsTable.loadedData.filter(campaign => campaign.selected);
  }

  updateSelectedCampaignsStatus(status) {
    const activeSelected = this.selectedCampaigns.filter(campaign => campaign.status === 'active');
    if (status === 'paused' && activeSelected.length) {
      this.promptStopReason().then(stopReason => {
        if (!stopReason) { return; }
        this.selectedCampaigns.forEach(campaign => this.updateCampaignStatus({campaign, status, stopReason}));
      });
    } else {
      this.selectedCampaigns.forEach(campaign => this.updateCampaignStatus({campaign, status}));
    }
  }

  promptStopReason() {
    return this.ModalService.showModal({
      template: stopReasonModalTemplate(),
      controllerAs: 'vm',
      controller: 'StopReasonModalController',
      inputs: {
        stopReasons: this.stopReasonsOptions
      }
    }).then(modal => modal.close);
  }

  updateCampaignStatus({campaign, status, stopReason}) {
    let newStatus;
    let discontinueCampaign;
    if (status === 'active') {
      if (campaign.status === 'paused') {
        campaign.start_date = moment().format('YYYY-MM-DD 00:00:00');
        campaign.start_mode = 'immediate';
        this.notify.warning('campaignActivateImmediate');
        newStatus = status;
        this.notify.warning('willActivateSegments');
      } else if (campaign.status === 'paused_due_to_budget') {
        this.notify.warning('pausedDueToBudgetCampaignActivated');
      }
    } else if (status === 'paused') {
      if (campaign.status == 'active') {
        delete campaign.start_date;
        delete campaign.end_date;
        campaign.start_mode = 'dont_start';
        campaign.end_mode = 'never';
        campaign.stop_reason = stopReason;
        newStatus = status;
        this.notify.warning('campaignPausingImmediate');
      } else if (campaign.status === 'paused_due_to_budget') {
        campaign.end_mode = 'specific_date';
        campaign.end_date = moment().startOf('day').add(1, 'days').format('YYYY-MM-DD');
        this.notify.warning('pausedDueToBudgetCampaignPaused');
        discontinueCampaign = true;
      }
    }
    if (newStatus) {
      campaign.status = status;
      campaign.save();
    } else if (discontinueCampaign) {
      campaign.save();
    }
  }

  getDailyOverviewFilename(){
    return `Daily_${this.$stateParams.gameId}_${moment(this.timeframe.startDate).format('YYYY-MM-DD')}_${moment(this.timeframe.endDate).format('YYYY-MM-DD')}.csv`;
  }

  getAggregatedOverviewFilename(){
    return `Aggregated_${this.$stateParams.gameId}_${moment(this.timeframe.startDate).format('YYYY-MM-DD')}_${moment(this.timeframe.endDate).format('YYYY-MM-DD')}.csv`;
  }

  exportDailyOverviewHeader() {
    const headers = ['date', 'campaign_id', 'campaign_name', 'impressions', 'clicks', 'engaged_players', 'app_open', 'click_through_rate', 'conversion_rate', 'ecpm', 'ecpc', 'ecpi', 'ecpa', 'cost', 'budget_amount', 'end_date'];
    return headers.map(h => this.translate(h).trim());
  }

  exportDailyOverview() {
    const toExport = _.isEmpty(this.selectedCampaigns) ? this.campaignsTable.loadedData : this.selectedCampaigns;
    const ids = toExport.map(c => c.id);
    const campaignEndDates = _.reduce(toExport, function(result, camp) {
      result[[camp.id]] = !_.isNull(camp.end_date) ? moment.utc(camp.end_date).format('YYYY-MM-DD HH:mm:ss') : '';
      return result;
    }, {});
    const idsToCampaigns = _.reduce(toExport, function(result, camp) {
      result[[camp.id]] = {...camp, end_date: !_.isNull(camp.end_date) ? moment.utc(camp.end_date).format('YYYY-MM-DD HH:mm:ss') : ''};
      return result;
    }, {});

    const deferred = this.$q.defer();
    this.isResourceBeingLoaded = true;

    this.CampaignAnalyticsResource.one('dailyOverview').get({
      game_id: this.$stateParams.gameId,
      campaign_ids: ids,
      start_date: this.apiDate(this.timeframe.startDate),
      end_date: this.apiDate(this.timeframe.endDate)
    }).then((res) => {

      const filtered = _.filter(res.data, d => ids.includes(d.campaign_id))
      const sorted = filtered.sort(function (a, b) {
        return a.date.localeCompare(b.date) || a.campaign_id - b.campaign_id;
      });

      this.isResourceBeingLoaded = false;
      deferred.resolve(_.map(sorted, (row) => {
        return {
          date: row.date,
          campaign_id: row.campaign_id,
          campaign_name: idsToCampaigns[row.campaign_id].name,
          impressions: row.impressions,
          clicks: row.clicks,
          engaged_players: row.engaged_players,
          app_open: row.app_open,
          click_through_rate: row.click_through_rate,
          conversion_rate: row.conversion_rate,
          ecpm: row.ecpm,
          ecpc: row.ecpc,
          ecpi: row.ecpi,
          ecpa: row.ecpa,
          cost: row.cost,
          budget_amount: row.total_budget,
          end_date: idsToCampaigns[row.campaign_id].end_date,
        };
      }));
    })
    return deferred.promise
  }

  exportSelected() {
    const toExport = _.isEmpty(this.selectedCampaigns) ? this.campaignsTable.loadedData : this.selectedCampaigns;

    return toExport.map(campaign => {
      return {
        campaign_id: campaign.id,
        campaign_name: campaign.name,
        impressions: campaign.impressions,
        clicks: campaign.clicks,
        conversions: campaign.conversions,
        app_open: campaign.app_open,
        click_through_rate: campaign.click_through_rate,
        conversion_rate: campaign.conversion_rate,
        ecpm: campaign.ecpm,
        ecpc: campaign.ecpc,
        ecpi: campaign.ecpi,
        ecpa: campaign.ecpe,
        roi_d7: campaign.roi_d7,
        cost: campaign.cost,
        budget_amount: campaign.budget_amount,
        end_date: moment(campaign.end_date).format('YYYY-MM-DD HH:mm:ss'),
      }
    });
  }

  exportHeader() {
    return _.keys(this.exportSelected()[0] || {}).map(label => this.translate(label).trim());
  }

  filterByCampaignAdvertisingType(campaign_advertising_type) {
    this.campaign_advertising_type = campaign_advertising_type;
    this.campaignsTable.filter().campaign_advertising_type = campaign_advertising_type;
  }

  filterByStatus(status) {
    this.campaignStatusFilterValue = status;
    this.campaignsTable.filter()['status'] = status;
  }

  filterByCreatives() {
    const selectedCreativesCampaignIds = _.chain(this.allCreatives).filter(c => c.selected).map(c => c.campaign_ids).flatten().uniq().value()
    this.campaignsTable.filter()['inIds'] = selectedCreativesCampaignIds;
  }

  get campaignsByType() {
    return _.chain(this.campaignsTable.loadedData).filter(this.type ? {type: this.type} : {}).value();
  }

  get totalDailyBudget() {
    return _.chain(this.campaignsByType)
      .filter(campaign => !/^pause/.test(campaign.status))
      .map('budget_amount').sum().value();
  }
}

export function CampaignsIndexComponent() {
  return {
    template,
    controller: CampaignsIndexController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {
      title: '='
    },
    bindToController: true
  };
};

export default angular.module('app.components.campaigns.index', [
  'ngCsv',
  'angularModalService',
  ConfigsModule.name,
  ServicesModule.name,
  ResourcesModule.name,
  StopReasonModal.name
])
.directive('campaignsIndex', CampaignsIndexComponent);



/** WEBPACK FOOTER **
 ** ./src/components/campaigns/campaignsIndex.js
 **/